import { render, staticRenderFns } from "./talentGroup.vue?vue&type=template&id=2a366816&scoped=true"
import script from "./talentGroup.vue?vue&type=script&lang=js"
export * from "./talentGroup.vue?vue&type=script&lang=js"
import style0 from "./talentGroup.vue?vue&type=style&index=0&id=2a366816&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a366816",
  null
  
)

export default component.exports